import "./JobDetailsModal.css";
import closeIcon from "../../../Assets/Icons/close-icon.svg";
import checkRightIcon from "../../../Assets/Icons/check-right-icon.svg";

const JobDetailsModal = ({ job, onClose }) => {
  if (!job) return null;

  return (
    <div className="job-modal-overlay" onClick={onClose}>
      <div className="job-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="job-modal-close" onClick={onClose}>
          <img src={closeIcon} alt="job-modal close icon" />
        </button>

        <h2 className="job-modal-title">{job.title}</h2>

        <button
          className="job-apply-button"
          onClick={() => {
            window.location.href = `mailto:${job.email || "hr@quadtheoryltd.com"}`;
          }}
        >
          APPLY VIA EMAIL
        </button>

        <div className="job-divider"></div>

        <h3 className="job-modal-section-title">Job Details</h3>
        <div className="job-details-row">
          <div className="job-detail-item">
            <strong>Job Location:</strong> {job.location || "Work from home"}
          </div>
          <div className="job-detail-item">
            <strong>Position:</strong> {job.position || job.title}
          </div>
          <div className="job-detail-item">
            <strong>Duration:</strong> {job.duration}
          </div>
        </div>

        <h3 className="job-modal-section-title">Minimum Skill Set</h3>
        <ul className="job-skills-list">
          {job.skills?.map((skill, index) => (
            <li key={index} className="job-skill-item">
              <img
                src={checkRightIcon}
                alt="checkmark icon"
                className="job-checkmark"
              />
              {skill}
            </li>
          ))}
        </ul>

        <h3 className="job-modal-section-title">Contact Information</h3>
        <div className="job-contact-info">
          <p>
            <strong>Email:</strong>{" "}
            <a href={`mailto:${job.email || "hr@quadtheoryltd.com"}`}>
              {job.email || "hr@quadtheoryltd.com"}
            </a>
          </p>
          <p>
            <strong>Subject Line:</strong>{" "}
            {job.subjectLine || "QT_DOTNET_I_02023"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default JobDetailsModal;
